import { Fragment } from "react";
import { useTranslation } from "@1f/react-sdk";
import Grid from "@vapor/react-material/Grid";
import Button from "@vapor/react-material/Button";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { AdapterDateFns } from "@vapor/react-x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@vapor/react-x-date-pickers/LocalizationProvider";
import { DatePicker } from "@vapor/react-x-date-pickers/DatePicker";
import { it } from "date-fns/locale";
import { isDateValid } from "../../businessLogic/helpers/dateHelpers";

export const AnagraficaIdentificazioneSection = ({
  currentAnagrafica,
  baseTipoIdentList,
  baseTipoDocList,
  utentiList,
  isModIdentArt22,
  showDocTipoAp,
  showDocTipoDetails,
  tipoAnag,
  isPG,
  isCessato,
  isNotLastVersion,
  onChange,
  onIdentDateChange,
  onDocRilDateChange,
  onDocScadChange,
  onBlurDate,
  onEuroConfClick,
}) => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Grid container justifyContent="center" alignItems="flex-start">
        <Grid item xs={4}>
          <ExtendedTypography variant="titleSmall" color="primary.main">
            {t("anagrafica.anagraficaForm.ident")}
          </ExtendedTypography>
        </Grid>
        <Grid item xs={8} sx={{ textAlign: "right" }}>
          <Button
            variant="text"
            size="small"
            startIcon={<img src="/img/EcLogo.png" width={20} alt="EcLogo" />}
            sx={{ width: "fit-content !important" }}
            onClick={() => onEuroConfClick(17237)}
          >
            {t("anagrafica.anagraficaForm.adegVer")}
          </Button>
          {tipoAnag === "titolare" ? (
            <Button
              variant="text"
              size="small"
              startIcon={<img src="/img/EcLogo.png" width={20} alt="EcLogo" />}
              sx={{ width: "fit-content !important" }}
              onClick={() => onEuroConfClick(17238)}
            >
              {t("anagrafica.anagraficaForm.titAnt")}
            </Button>
          ) : null}
        </Grid>
      </Grid>

      <Autocomplete
        id="ddlModIdent"
        size="small"
        options={
          tipoAnag === "titolare"
            ? baseTipoIdentList
            : baseTipoIdentList.filter((x) => x.key !== "tipo_identificazione_2")
        }
        sx={{ width: "100%" }}
        fullWidth
        onChange={onChange}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.value}
        value={
          baseTipoIdentList.find(item => item.id === currentAnagrafica.modalitaIdentId) ?? null
        }
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label="Modalità identificazione"
            sx={{ lineHeight: 1 }}
          />
        )}
        readOnly={isCessato || isNotLastVersion}
      />

      <Fragment>
        <Grid container>
          <Grid item xs={isModIdentArt22 ? 6 : 4} sx={{ pr: 2 }}>
            <Autocomplete
              id="ddlIdentBy"
              size="small"
              options={utentiList}
              sx={{ width: "100%" }}
              fullWidth
              onChange={onChange}
              readOnly={isCessato || isNotLastVersion}
              isOptionEqualToValue={(option, value) =>
                currentAnagrafica.identifiedByUser === undefined
                  ? option.userId === value.userId
                  : option.userId === currentAnagrafica.identifiedByUser
              }
              getOptionLabel={(option) => option.completeName}
              defaultValue={
                utentiList.filter(
                  (item) => item.userId === currentAnagrafica.identifiedByUser
                )[0] ?? null
              }
              renderInput={(params) => (
                <TextField {...params} required label="Identificato da" sx={{ lineHeight: 1 }} />
              )}
            />
          </Grid>
          <Grid item xs={isModIdentArt22 ? 6 : 4} sx={isModIdentArt22 ? {} : { pr: 2 }}>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
              <DatePicker
                label="Identificato in data"
                closeOnSelect
                format="dd/MM/yyyy"
                mask="__/__/____"
                value={
                  isDateValid(currentAnagrafica.identifiedOn)
                    ? new Date(currentAnagrafica.identifiedOn)
                    : null
                }
                onChange={onIdentDateChange}
                slotProps={{
                  textField: {
                    required: true,
                    placeholder: "dd/MM/yyyy",
                    size: "small",
                    fullWidth: true,
                  },
                }}
                readOnly={isCessato || isNotLastVersion}
              />
            </LocalizationProvider>
          </Grid>
          {!isModIdentArt22 ? (
            <Grid item xs={4}>
              <Autocomplete
                id="ddlModIdentDoc"
                size="small"
                fullWidth
                options={
                  isPG
                    ? baseTipoDocList.filter(
                        (x) =>
                          x.personType === "PG" ||
                          x.personType === null ||
                          x.personType === ""
                      )
                    : baseTipoDocList.filter(
                        (x) =>
                          x.personType === "PF" ||
                          x.personType === null ||
                          x.personType === ""
                      )
                }
                sx={{ width: "100%" }}
                onChange={onChange}
                isOptionEqualToValue={(option, value) =>
                  currentAnagrafica.docTipoId === undefined
                    ? option.id === value.id
                    : option.id === currentAnagrafica.docTipoId
                }
                getOptionLabel={(option) => option.value}
                defaultValue={
                  currentAnagrafica.docTipoId !== undefined
                    ? baseTipoDocList.filter(
                        (item) => item.id === currentAnagrafica.docTipoId
                      )[0]
                    : null
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    required
                    label="Verificato tramite"
                    sx={{ lineHeight: 1 }}
                  />
                )}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
          ) : null}
        </Grid>

        {!isModIdentArt22 && showDocTipoDetails ? (
          <Grid container>
            <Grid item xs={2} sx={{ pr: 2 }}>
              <TextField
                id="txtDocN"
                label="Numero"
                size="small"
                fullWidth
                defaultValue={currentAnagrafica.docN}
                onChange={onChange}
                inputProps={{ autocomplete: "nope", maxLength: 100 }}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
            <Grid item xs={4} sx={{ pr: 2 }}>
              <TextField
                id="txtDocRilDa"
                label="Rilasciato da"
                size="small"
                fullWidth
                defaultValue={currentAnagrafica.docRilDa}
                onChange={onChange}
                inputProps={{ autocomplete: "nope", maxLength: 255 }}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
            <Grid item xs={3} sx={{ pr: 2 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
                <DatePicker
                  label="Rilasciato il"
                  closeOnSelect
                  format="dd/MM/yyyy"
                  mask="__/__/____"
                  maxDate={
                    isDateValid(currentAnagrafica.docRilData)
                      ? new Date(currentAnagrafica.docRilData)
                      : null
                  }
                  value={
                    isDateValid(currentAnagrafica.docRilData)
                      ? new Date(currentAnagrafica.docRilData)
                      : null
                  }
                  onChange={onDocRilDateChange}
                  slotProps={{
                    textField: {
                      required: true,
                      placeholder: "dd/MM/yyyy",
                      size: "small",
                      fullWidth: true,
                      onBlur: onBlurDate,
                    },
                  }}
                  readOnly={isCessato || isNotLastVersion}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
              <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
                <DatePicker
                  label="Scade il"
                  closeOnSelect
                  format="dd/MM/yyyy"
                  mask="__/__/____"
                  minDate={
                    isDateValid(currentAnagrafica.docRilData)
                      ? new Date(currentAnagrafica.docRilData)
                      : null
                  }
                  value={
                    isDateValid(currentAnagrafica.docScad)
                      ? new Date(currentAnagrafica.docScad)
                      : null
                  }
                  onChange={onDocScadChange}
                  slotProps={{
                    textField: {
                      required: true,
                      placeholder: "dd/MM/yyyy",
                      size: "small",
                      fullWidth: true,
                    },
                  }}
                  readOnly={isCessato || isNotLastVersion}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        ) : null}
      </Fragment>

      {showDocTipoAp ? (
        <Grid container>
          <Grid item xs={8} sx={{ pr: 2 }}>
            <TextField
              id="txtApNome"
              label="Denominazione altro professionista"
              size="small"
              fullWidth
              defaultValue={currentAnagrafica.apNome}
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 255 }}
              readOnly={isCessato || isNotLastVersion}
            />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="txtApCf"
              label={t("anagrafica.ImportDesktop.codFisc")}
              size="small"
              fullWidth
              defaultValue={currentAnagrafica.apCf}
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 100 }}
              readOnly={isCessato || isNotLastVersion}
            />
          </Grid>
        </Grid>
      ) : null}
    </Fragment>
  );
};
